import Mixpanel from './Mixpanel';
import { underscore } from 'HELPERS/text';
import SharedMixpanel from './SharedMixpanel';


export default class PreferabliAnalytics{
  constructor(){
    this.product_id = null;
    this.integration_id = null;
    this.mp = null;
  }

  setup({ integration_id, opt_out_tracking }){
    this.integration_id = integration_id;

    if(!opt_out_tracking) {
      this.mp = new Mixpanel();

      const mix = new SharedMixpanel({token: __MIXPANEL_SINGLETON__, integration_id});
      mix.createOrWaitForInstance().then(instance => {
        this.mp.instance = instance;
      });
    }

  }

  setProductId(product_id){
   this.product_id = product_id;
  }

  setIntegrationId(integration_id){
   this.integration_id = integration_id;
  }

  track(event, params){
    const _defaults = {
      lttt_rec_product_id: `${this.product_id}`,
      lttt_rec_product_url: `${window.location.href}`,
      integration_id: `${this.integration_id}`,
      integration_hostname: `${window.location.hostname}`,
      integration_href: `${window.location.href}`,
    }

    if(this.mp) {
      this.mp.track(event, { ...params, ..._defaults });
    }
  }

  track_time_event(event){
      if(this.mp) this.mp.track_time_event(event);
  }
  
}